export interface AddAliasInput {
  projectName: string;
  toAddress: string;
  addresses: string[];
  existingMailServer: boolean;
}
